import gql from 'graphql-tag';

export const FeedCardAllActivityQuery = gql`
	query FeedCardAllActivityQuery($contentId: ID!, $after: String, $fromDate: String) {
		pageActivity(contentId: $contentId, after: $after, fromDate: $fromDate) {
			nodes {
				timestamp
				action
				actionSubject
				... on PageActivityEventCreatedPage {
					groupSize
					user {
						...FeedCardAllActivityUserFragment
					}
				}
				... on PageActivityEventUpdatedPage {
					pageVersion
					groupSize
					user {
						...FeedCardAllActivityUserFragment
					}
				}
				... on PageActivityEventCreatedComment {
					groupSize
					comment {
						id
						links {
							webui
						}
					}
					user {
						...FeedCardAllActivityUserFragment
					}
				}
			}

			pageInfo {
				endCursor
				hasNextPage
			}
		}
	}

	fragment FeedCardAllActivityUserFragment on AtlassianUser {
		id
		displayName
		photos {
			value
			isPrimary
		}
	}
`;
